/**
 * NDL Manual Products
 * Mobile Swiper for manually curated product rows. Desktop stays a stable grid.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 739px)';
  var mediaQuery = window.matchMedia(MOBILE_QUERY);

  function initSection(section) {
    if (!section || section.dataset.ndlManualProductsReady === 'true') return;

    var swiperEl = section.querySelector('.ndl_manual-products__swiper');
    if (!swiperEl) return;
    if (typeof window.Swiper === 'undefined') {
      var attempts = Number(section.dataset.ndlManualProductsSwiperAttempts || 0);
      if (attempts >= 20) return;
      section.dataset.ndlManualProductsSwiperAttempts = String(attempts + 1);
      window.setTimeout(function () {
        initSection(section);
      }, 120);
      return;
    }

    var swiper = null;

    function enableSwiper() {
      if (swiper || !mediaQuery.matches) return;

      swiper = new window.Swiper(swiperEl, {
        slidesPerView: 1.35,
        spaceBetween: Number(section.style.getPropertyValue('--ndl-manual-mobile-gap').replace('px', '')) || 16,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: section.querySelector('.ndl_manual-products__pagination'),
          clickable: true
        },
        breakpoints: {
          480: {
            slidesPerView: 2.15
          }
        }
      });
    }

    function disableSwiper() {
      if (!swiper || mediaQuery.matches) return;

      swiper.destroy(true, true);
      swiper = null;
    }

    function sync() {
      if (mediaQuery.matches) {
        enableSwiper();
      } else {
        disableSwiper();
      }
    }

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', sync);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(sync);
    }

    section.dataset.ndlManualProductsReady = 'true';
    sync();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ndl-manual-products]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
